export enum SaveQuoteDialog {
  id = 'save-quote-dialog',
  title = 'Saving, please wait',
  spinner = 'true',
  disableClose = 'true'
}
